import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Stack } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

// schema
const schema = yup.object({
  sisvehnom: yup.string().required('El nombre del sistema es obligatorio').max(100, 'Máximo 100 caracteres'),
  sisvehdes: yup.string().nullable().max(255, 'Máximo 255 caracteres'),
});

const SystemVehicleForm = ({ open, onClose, onSubmit, defaultValues = {} }) => {
  const {
    register, handleSubmit, formState: { errors, isSubmitting }, reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  useEffect(() => {
    if (open) reset(defaultValues);
  }, [open, defaultValues, reset]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{defaultValues?.sisvehid ? 'Editar Sistema Vehicular' : 'Nuevo Sistema Vehicular'}</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Stack spacing={2}>
            <TextField
              label="Nombre del Sistema"
              {...register('sisvehnom')}
              error={!!errors.sisvehnom}
              helperText={errors.sisvehnom?.message}
              autoFocus
              fullWidth
            />
            <TextField
              label="Descripción (opcional)"
              {...register('sisvehdes')}
              error={!!errors.sisvehdes}
              helperText={errors.sisvehdes?.message}
              fullWidth
              multiline
              minRows={2}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={isSubmitting}>
            {defaultValues?.sisvehid ? 'Actualizar' : 'Guardar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default SystemVehicleForm;
